module.exports = __webpack_public_path__ + "img/lh.7ed717eb.png";